export default __webpack_public_path__ + "static/media/006-bbq.1c11274c.svg";